import request from '@/utils/request'

export default {
    // 集团新闻详情
    index: params => {
        return request({
            url: '/about/detail',
            method: 'POST',
            params
        })
    },
    //新闻列表
    aboutlist: params => {
        return request({
            url: '/about/list',
            method: 'POST',
            params
        })
    },
    //新闻推荐列表
    recommend: params => {
        return request({
            url: '/about/tList',
            method: 'POST',
            params
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/about.js